export const WORKFLOW_VARIABLE_REGEX = /\{\{[a-zA-Z0-9_.]+\}\}/;

export function containsWorkflowVariable(value: unknown): boolean {
  return typeof value === 'string' && WORKFLOW_VARIABLE_REGEX.test(value);
}
